var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafficIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5905 15.1607H1.64246M13.5905 15.1607L14.3044 12.3044C14.4396 11.7652 14.2633 11.1947 13.8481 10.8258L12.8438 9.93342M13.5905 15.1607H11.3502V16.2808C11.3502 16.4869 11.5175 16.6542 11.7236 16.6542H13.2171C13.4232 16.6542 13.5905 16.4869 13.5905 16.2808V15.1607ZM1.64246 15.1607L0.92856 12.3044C0.793397 11.7652 0.969631 11.1947 1.38483 10.8258L2.38921 9.93342M1.64246 15.1607H3.88272V16.2808C3.88272 16.4869 3.71544 16.6542 3.50934 16.6542H2.01583C1.80973 16.6542 1.64246 16.4869 1.64246 16.2808V15.1607ZM2.38921 9.93342L3.13596 6.94641C3.13596 6.94641 5.37622 6.19965 7.61648 6.19965C9.85674 6.19965 12.097 6.94641 12.097 6.94641L12.8438 9.93342M2.38921 9.93342H12.8438M16.8578 10.3072L17.5717 7.4509C17.7069 6.91174 17.5306 6.34122 17.1154 5.97233L16.1111 5.07996M16.8578 10.3072H14.6176V11.4274C14.6176 11.6335 14.7848 11.8007 14.9909 11.8007H16.4844C16.6905 11.8007 16.8578 11.6335 16.8578 11.4274V10.3072ZM16.8578 10.3072L13.2171 10.2652M4.65213 5.97233L5.65652 5.07996M5.65652 5.07996L6.40327 2.09294C6.40327 2.09294 8.64353 1.34619 10.8838 1.34619C13.124 1.34619 15.3643 2.09294 15.3643 2.09294L16.1111 5.07996M5.65652 5.07996H16.1111",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficIcon);
export default __webpack_public_path__ + "static/media/traffic-icon.cd9eb241638d8b133df377cbd0ac9466.svg";
export { ForwardRef as ReactComponent };